/** Align FAQ fetch/cache with site ISR (`revalidate = 3600`). */
export const SUPPORT_FAQS_REVALIDATE_SECONDS = 3600;

export const SUPPORT_FAQS_STALE_TIME_MS =
  SUPPORT_FAQS_REVALIDATE_SECONDS * 1000;
